export interface Logger {
    debug(message: string, ...args: any[]): void;
    info(message: string, ...args: any[]): void;
    warn(message: string, ...args: any[]): void;
    error(message: string, error?: Error, ...args: any[]): void;
}

class ConsoleLogger implements Logger {
    debug(message: string, ...args: any[]): void {
        if (process.env.NODE_ENV === 'development') {
            console.debug(`[DEBUG] ${message}`, ...args);
        }
    }

    info(message: string, ...args: any[]): void {
        console.info(`[INFO] ${message}`, ...args);
    }

    warn(message: string, ...args: any[]): void {
        console.warn(`[WARN] ${message}`, ...args);
    }

    error(message: string, error?: Error, ...args: any[]): void {
        console.error(`[ERROR] ${message}`, error, ...args);
    }
}

// Placeholder for SentryLogger
// class SentryLogger implements Logger {
//     debug(message: string, ...args: any[]): void {
//         // Sentry.captureMessage(message, 'debug');
//     }

//     info(message: string, ...args: any[]): void {
//         // Sentry.captureMessage(message, 'info');
//     }

//     warn(message: string, ...args: any[]): void {
//         // Sentry.captureMessage(message, 'warning');
//     }

//     error(message: string, error?: Error, ...args: any[]): void {
//         // Sentry.captureException(error, { extra: { message, args } });
//         console.error(message, error, ...args); // Fallback to console for visibility
//     }
// }

// Factory to create logger based on environment
const createLogger = (): Logger => {
    // TODO: Add check for Sentry DSN or specific env var to enable Sentry
    // if (process.env.NODE_ENV === 'production') {
    //   return new SentryLogger();
    // }
    return new ConsoleLogger();
};

export const logger = createLogger();
